import anime from 'animejs';

class NewsletterAnimations {
  static slide(element, back = false, callback = undefined) {
    anime({
      targets: element,
      translateX: [
        back ? { value: '-100%' } : { value: '0%' },
        back ? { value: '0%' } : { value: '-100%' },
      ],
      easing: 'easeOutSine',
      duration: 500,
    })
    .finished.then(() => {
      if (!callback) return;
      callback();
    });
  }

  static shake(element) {
    anime({
      targets: element,
      translateX: [
        { value: '0%' },
        { value: '5%' },
        { value: '-5%' },
        { value: '0%' },
      ],
      easing: 'easeOutSine',
      duration: 100,
    });
  }
}

export default NewsletterAnimations;



// WEBPACK FOOTER //
// ./components/NewsletterAnimations.js